(function() {
  // Helper to wait until posthog is loaded
  function runWithPostHog(callback) {
    if (window.posthog && typeof window.posthog.onFeatureFlags === 'function') {
      callback();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        let attempts = 0;
        const interval = setInterval(() => {
          attempts++;
          if (window.posthog && typeof window.posthog.onFeatureFlags === 'function') {
            clearInterval(interval);
            callback();
          } else if (attempts > 50) { // Timeout after 5 seconds
            clearInterval(interval);
            console.warn("PostHog initialization timed out.");
          }
        }, 100);
      });
    }
  }

  function safeGetLocalStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function normalizeVariant(raw) {
    if (raw === true) return 'treatment';
    if (raw === false) return 'control';
    if (raw === 'test') return 'treatment';
    if (raw === 'control' || raw === 'treatment' || raw === 'seed') return raw;
    return null;
  }

  runWithPostHog(() => {
    // 1. Page Context Extraction
    const pageType = window.ShopifyAnalytics?.meta?.page?.pageType || 'page';
    const pageTitle = document.title;
    const urlParams = new URLSearchParams(window.location.search);
    const queryVariant = urlParams.get('v') || '';

    function capturePageview() {
      const fullDaySetVariant = normalizeVariant(
        window.__mkFullDaySetExperiment?.variant ||
        document.documentElement.getAttribute('data-ab-variant') ||
        safeGetLocalStorage('full-day-set-ab-variant')
      );
      const fullDaySetSource = window.__mkFullDaySetExperiment?.source || 'unknown';

      // 2. A/B Testing & Feature Flags Coordination
      const experimentVariant = window.posthog.getFeatureFlag('landing-page-hero-variant');
      let activeVariant = queryVariant || experimentVariant || 'default';

      console.log(`[Moksae PostHog] Active Variant: ${activeVariant} (Query: "${queryVariant}", Experiment Flag: "${experimentVariant}")`);

      // If we have an active A/B test variant and applyVariant function exists on the landing page, trigger it
      const applyFn = window.mlApplyVariant || window.applyVariant;
      if (activeVariant && activeVariant !== 'default' && typeof applyFn === 'function') {
        applyFn(activeVariant);
      }

      window.posthog.capture('$pageview', {
        page_type: pageType,
        page_title: pageTitle,
        landing_variant: activeVariant,
        query_variant: queryVariant,
        experiment_variant: experimentVariant || 'none',
        full_day_set_experiment_name: fullDaySetVariant ? 'full-day-set-pdp-variant' : 'none',
        full_day_set_variant: fullDaySetVariant || 'none',
        full_day_set_variant_source: fullDaySetVariant ? fullDaySetSource : 'none'
      });
    }

    window.posthog.onFeatureFlags(() => {
      const sharedExperiment = window.__mkFullDaySetExperiment;
      if (sharedExperiment && sharedExperiment.ready && typeof sharedExperiment.ready.then === 'function') {
        sharedExperiment.ready.then(capturePageview).catch(capturePageview);
      } else {
        capturePageview();
      }
    });

    // 3. Exit Intent Detection
    // Desktop: Mouse leaving top of the window
    document.addEventListener('mouseleave', (e) => {
      if (e.clientY < 0) {
        window.posthog.capture('exit_intent_detected', {
          device_type: 'desktop',
          trigger_source: 'mouseleave',
          page_type: pageType,
          url: window.location.href
        });
      }
    });

    // Mobile: Scroll velocity or exit-intent patterns (rapid scroll up at the top)
    let lastScrollTop = 0;
    let lastScrollTime = Date.now();
    document.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const now = Date.now();
      const dt = now - lastScrollTime;
      if (dt > 50) {
        const speed = (lastScrollTop - scrollTop) / dt; // pixels per ms
        // If user scrolls up extremely fast (velocity > 1.5px/ms) near the top of the page (scrollTop < 300)
        if (speed > 1.5 && scrollTop < 300 && lastScrollTop > scrollTop) {
          window.posthog.capture('exit_intent_detected', {
            device_type: 'mobile',
            trigger_source: 'rapid_scroll_up',
            page_type: pageType,
            url: window.location.href
          });
        }
        lastScrollTop = scrollTop;
        lastScrollTime = now;
      }
    }, { passive: true });

    // 4. Custom Interaction Tracking (Add to Cart, Checkout, Buy Now clicks)
    document.addEventListener('click', (e) => {
      // 4a. Add to Cart Button Click
      const atcTarget = e.target.closest('#cart-cta, #sticky-btn, .byb__btn, .product-form__submit, #ml-add-to-cart-btn, .ml-sticky-btn');
      if (atcTarget) {
        let bundleName = 'Single Product / Custom';
        let checkedSticks = [];
        let totalPriceVal = '';

        const state = window.mlState || window.state;
        if (state) {
          if (typeof window.bundleLabel === 'function') {
            bundleName = window.bundleLabel();
          } else if (state.checked) {
            const count = state.checked.length;
            if (count === 3) bundleName = 'The Full Day Set';
            else if (count === 2) {
              if (state.checked.includes('morning') && state.checked.includes('midday')) {
                bundleName = 'The Work Day Set';
              } else if (state.checked.includes('midday') && state.checked.includes('night')) {
                bundleName = 'The Slow Down Set';
              } else {
                bundleName = 'The Bookend Set';
              }
            } else if (count === 1) {
              const item = state.checked[0];
              bundleName = { morning: 'Morning Clarity', midday: 'Midday Reset', night: 'Night Unwind' }[item] || item;
            }
            if (state.upsell) {
              bundleName += ' + Havan Cup';
            }
          }

          if (Array.isArray(state.checked)) checkedSticks = state.checked;

          if (typeof window.totalPrice === 'function') {
            totalPriceVal = window.totalPrice();
          } else if (document.getElementById('ml-price-current')) {
            totalPriceVal = document.getElementById('ml-price-current').textContent.replace('₹', '').trim();
          }
        }

        console.log('[Moksae PostHog] ATC Clicked:', { bundleName, checkedSticks, totalPriceVal });

        window.posthog.capture('add_to_cart_clicked', {
          page_type: pageType,
          bundle_name: bundleName,
          selected_sticks: checkedSticks,
          total_price: totalPriceVal,
          url: window.location.href
        });
      }

      // 4b. Checkout Button Click
      const checkoutTarget = e.target.closest('#checkout, #CartDrawer-Checkout, button[name="checkout"], .cart__checkout-button');
      if (checkoutTarget) {
        console.log('[Moksae PostHog] Checkout Clicked');
        window.posthog.capture('checkout_clicked', {
          page_type: pageType,
          url: window.location.href
        });
      }

      // 4c. Buy Now / Dynamic Checkout Button Click
      const buyNowTarget = e.target.closest('.shopify-payment-button, .shopify-payment-button__button, .shopify-payment-button button');
      if (buyNowTarget) {
        console.log('[Moksae PostHog] Buy Now Clicked');
        window.posthog.capture('buy_now_clicked', {
          page_type: pageType,
          url: window.location.href
        });
      }
    });

  });
})();
